<template>
  <Button
    variant="outline"
    size="icon"
    @click="isEditing = true"
  >
    <i class="tw:i-fal-pen-to-square" />
  </Button>
</template>

<script setup>
import { Button } from '@/shadcn/components/ui/button/index.js'
import { useTeleprompter } from './use-teleprompter.js'

const { isEditing } = useTeleprompter()
</script>
